module.exports = __webpack_public_path__ + "static/media/intro_icon_1.25b0dd87.svg";